module.exports = __webpack_public_path__ + "img/icon-check.e21fe3a8.png";